<template>
    <div>
        <el-input class="textarea-value mt30" type="textarea" v-model="ruleForm.desc"></el-input>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue } from '../../app.vues'

    export default {
        name: 'swb-apply-desc',
        desc: '审核',
        props: ['desc'],
        data: function () {
            return {
                ruleForm: {}
            }
        },
        created: function () {
            let thisDesc = this.desc;
            if(!Utils.isNoB(thisDesc)) {
                let params = {
                    desc: thisDesc
                };
                this.ruleForm = Utils.merge({}, params);
            }
        },
        methods: {
            getDlgResult: function () {
                let self = this;
                let result = {};
                result.type = "info";
                result.data = self.ruleForm;
                return result;
            }
        }
    }
</script>
<style>
    .textarea-value.el-textarea > textarea {
        height: 120px;
    }
</style>




// WEBPACK FOOTER //
// src/compo/stock/ApplyDesc.vue